'use client';
import React from 'react';
import PublicTopbar from './PublicTopbar';
import { useLanguage } from '@/context/LanguageContext';

interface PublicLayoutProps {
  children: React.ReactNode;
}

export default function PublicLayout({ children }: PublicLayoutProps) {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <PublicTopbar />
      <main className="flex-1">{children}</main>
      <footer className="bg-white border-t border-border py-8 mt-auto">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <span className="text-white font-display font-bold text-sm">T</span>
            </div>
            <span className="font-display font-semibold text-foreground text-sm">Tota for Cleaning and Hospitality</span>
          </div>
          <p className="text-muted-foreground text-sm">
            {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <span className="cursor-pointer hover:text-primary transition-colors">{t('footer.privacy')}</span>
            <span className="cursor-pointer hover:text-primary transition-colors">{t('footer.terms')}</span>
            <span className="cursor-pointer hover:text-primary transition-colors">{t('footer.support')}</span>
          </div>
        </div>
      </footer>
    </div>
  );
}